import { Collection } from 'modules/core/lib/mobx-rest'

import AccessGroupMembership from 'modules/dashboard/store/models/AccessGroupMembership'

/**
 * @deprecated Do not use the generic access group membership model, we're removing it from the API. Create a domain specific entity instead.
 */
class AccessGroupMemberships extends Collection<AccessGroupMembership> {
  get cacheKey(): string {
    return 'accessGroupMemberships'
  }

  get indexes() {
    return ['access_id', 'access_group_id']
  }

  model() {
    return AccessGroupMembership
  }

  async create(_attributes: unknown, _options: unknown): Promise<never> {
    throw new Error("Can't modify generic access group memberships through the API")
  }

  async delete(_model: unknown) {
    throw new Error("Can't modify generic access group memberships through the API")
  }
}

export default new AccessGroupMemberships()
